import LabelHello from './LabelHello-redux';

export default LabelHello;
